<template>
  <div class="queries">
    <h1 class="page-title">Queries</h1>

    <ul class="page-actions">
      <li><router-link to="/queries/new">Create query</router-link></li>
    </ul>

    <div class="page-content">
      <div v-if="queries.length > 0" class="basic-list">
        <ul>
          <li v-for="query in queries" :key="query.id">
            <router-link :to="{ path: '/queries/' + query.id }">{{ query.label }}</router-link>
          </li>
        </ul>
      </div>

      <div v-else>
        <router-link to="/queries/new">Create first query</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import auth from "@/helpers/auth";

export default {
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },

  computed: {
    ...mapState({
      queries: (state) => state.queries.all
    })
  }
};
</script>
